<template>
    <v-dialog v-model="shows" max-width="724" width="100%" content-class="rounded-lg" eager>
        <template #activator="{ attrs, on }">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>

        <v-sheet class="fill-height">
            <v-layout column fill-height>
                <bottom-sheet-header style="position: relative">
                    <v-btn small text fab tile absolute right color="white" @click="$emit('showComplete')"> <v-icon>mdi-close</v-icon> </v-btn>
                </bottom-sheet-header>
                <div class="scroll-primary" style="flex: 1 1 auto; overflow-y: auto">
                    <v-sheet class="pa-40 pa-lg-60">
                        <div class="text-center">
                            <h3 class="tit mb-8 mb-lg-16">송부 완료</h3>
                            <p class="page-text--lg grey-6--text">
                                계약서가 송부 되었습니다. <br>
                                근로자 현황에서 확인 가능합니다.
                            </p>
                        </div>
                        <div class="v-btn-group">
                            <v-btn outlined color="grey-d" class="min-w-140px min-w-lg-160px" @click="$emit('showComplete')"><span class="grey-6--text">확인</span></v-btn>
                            <texting-dialog v-bind="textingProps">
                                <template #activator="{ attrs, on }">
                                    <v-btn v-bind="attrs" v-on="on" color="primary" class="min-w-140px min-w-lg-160px">
                                        <span>문자발송</span>
                                    </v-btn>
                                </template>
                            </texting-dialog>
                        </div>
                    </v-sheet>
                </div>
            </v-layout>
        </v-sheet>
    </v-dialog>
</template>

<script>
import BottomSheetHeader from "@/components/dumb/bottom-sheet-header.vue";
import TextingDialog from "@/components/dashboard/company/texting/texting-dialog.vue";

export default {
    components: {
        BottomSheetHeader,
        TextingDialog
    },
    props:{
        applicants: { type: Array, default: () => {[]}}
    },
    data: () => ({
        shows: true,
    }),
    computed:{
    textingProps() {
        return {
            value: this.applicants,
            applications: this.applicants,
        };
    },
    },
    mounted() {
    },
    methods: {
    },
};
</script>

<style lang="scss" scoped>
.v-dialog__content.v-dialog__content--active{
    z-index: 212 !important;
    background-color: rgba(33, 33, 33, .46);
}
</style>